import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin } from "antd";
import React from "react";
import request from "../../api/request/http-service";
import { SERVER_ADDRESSES } from "../../config/serverAddressesConfig";
import { BACK_OFFICE_API_APPLICATIONS_CONTROLLER_END_POINTS } from "../../config/apiEndPoints/BackOfficeApiEndPoints/ApplicationsController";
import { useSelector } from "react-redux";
import { makeSelectCurrencies, makeSelectHost, makeSelectTransportCharacteristics } from "../../containers/App/selectors";
import { ApplicationDataConverter, ApplicationModel } from "../../viewModels/Applications/ApplicationModel";
import { ApplicationDto } from "../../dto/Applications/ApplicationDto";
import ApplicationSummary from "../V2Components/ApplicationSummary";
import CalculationTable from "../Calculations/components/CalculationTable";

type Props = {
  applicationId: number;
  calculationId: number;
};

const RateInfo = React.memo(({ applicationId, calculationId }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [application, setApplication] = React.useState<ApplicationModel | undefined>();
  const calculation = application ? application.calculations.find((x) => x.id === calculationId) : undefined;

  const host = useSelector(makeSelectHost());
  const transportCharacteristics = useSelector(makeSelectTransportCharacteristics());
  const currencies = useSelector(makeSelectCurrencies());

  const handleClick = async () => {
    setOpen(true);
    setLoading(true);
    const res = (await request(
      {
        server: SERVER_ADDRESSES.BACK_OFFICE_API,
        controller: BACK_OFFICE_API_APPLICATIONS_CONTROLLER_END_POINTS.CONTROLLER_PATH + "/" + applicationId,
        requestMethod: "get",
        body: {},
        query: {},
        headers: {},
      },
      host,
    )) as { application: ApplicationDto };

    const applicationDto: ApplicationDto = res.application;

    setLoading(false);
    setApplication(
      ApplicationDataConverter.convertApplication(
        res.application,
        transportCharacteristics.find((x) => x.id === applicationDto.filter.transportCharacteristicId)!,
        host,
        currencies.find((x) => x.id === applicationDto.filter.currencyId),
      ),
    );
  };

  const handleCloseModal = () => {
    setOpen(false);
    setApplication(undefined);
  };

  return (
    <>
      <Modal open={open} footer={null} onCancel={handleCloseModal} width={1200} closable={false}>
        {loading ? (
          <Flex justify="center">
            <Spin spinning />
          </Flex>
        ) : (
          <Flex vertical gap={16}>
            {application && <ApplicationSummary application={application} />}
            {calculation && (
              <CalculationTable
                calculationSegments={calculation.calculationSegments || []}
                services={calculation.serviceCostCalculations}
                calculationUuid={calculation.uuid}
                creator={calculation.creator}
                readonly
              />
            )}
          </Flex>
        )}
      </Modal>
      <Button icon={<InfoCircleOutlined />} size="small" type="text" onClick={handleClick} />
    </>
  );
});

export default RateInfo;
